import axios from "axios";
import firebase from "firebase/app";

import * as constants from "../../constants";

const GetItem = (path, refreshJwt = true) => {
	return new Promise((resolve, reject) => {
		if (firebase.auth().currentUser) {
			firebase
				.auth()
				.currentUser.getIdToken(refreshJwt)
				.then(token => {
					const api = axios.create({
						baseURL: constants.BASE_API_URL,
						timeout: 60000,
						headers: { Authorization: "Bearer " + token },
					});
					api.get(path)
						.then(res => {
							resolve(res);
						})
						.catch(error => {
							reject(error);
						});
				});
		} else {
			reject("Unauthorized");
		}
	});
};

export default GetItem;
